import React from 'react'

import { useShallow } from 'zustand/react/shallow'

import AskHarveyButton from '../../components/AskHarveyButton'
import {
  Card,
  CardContent,
  CardFooter,
} from '@harvey-frontend/components/ui/card'
import { Textarea } from '@harvey-frontend/components/ui/text-area'

import {
  PLACEHOLDER_REVISE,
  PLACEHOLDER_INSERT,
} from '../../../../utils/constants'
import { RequestMode } from '../../../../utils/constants'
import { useRequestMode } from '../../hooks/useRequestMode'
import useAppStore from '../../stores/store'

const Instruction = () => {
  const mode = useRequestMode()
  const { instruction, setInstruction, isDisabled } = useAppStore(
    useShallow((s) => ({
      instruction: s.instruction,
      setInstruction: s.setInstruction,
      isDisabled: s.isFetching || s.isApplyingSuggestion,
    }))
  )

  return (
    <Card className="flex max-h-[25vh] min-h-32 flex-col justify-between rounded border ring-offset-primary focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2">
      <CardContent className="flex-[3] overflow-auto p-2 pb-0.5">
        <Textarea
          className="min-h-full resize-none border-none p-0 text-sm placeholder:text-xs focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
          isFluid
          placeholder={
            mode === RequestMode.INSERT
              ? PLACEHOLDER_INSERT
              : PLACEHOLDER_REVISE
          }
          disabled={isDisabled}
          value={instruction}
          onChange={(e) => setInstruction(e.target.value)}
        />
      </CardContent>
      <CardFooter className="flex-initial basis-8 border-t p-0">
        <div className="w-full p-1">
          <AskHarveyButton />
        </div>
      </CardFooter>
    </Card>
  )
}

export default Instruction
